export const config = window.sherpaConfig;

export default config;
